import messageCategory from "./category"
import systemSet from './systemSet'
import payChannelInterface from "./payChannelInterface"
const system = {
    path: '/system',
    component: resolve => require(['@/pages/admin/system'], resolve),
    redirect: '/system/category',
    children: [
        messageCategory,
        systemSet,
        payChannelInterface
    ],
    meta: {
        requireAuth: true
    }
}

export default system